import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { ShowEventPageSwiperDefaultStyles } from '@styles/components';
import Swiper from '../Swiper';

type Props = {
  id: string,
  showDate: boolean,
  title: string | null,
  videos: any[],
}

function VideoSwiper({
  id, showDate = false, title, videos,
}: Props) {
  const swiperItems = videos.map((item: any) => (
    <ShowEventPageSwiperDefaultStyles.SwiperItemWrapper key={item.id}>
      <div className="group mx-[5px] w-[258px]">
        <Link to={`${item.slug}`}>
          <ShowEventPageSwiperDefaultStyles.SwiperItem>
            <ShowEventPageSwiperDefaultStyles.SwiperItemImgWrapper>
              <GatsbyImage
                image={getImage(item?.thumbnailMediaStandard?.gatsbyImageData)!}
                alt={item?.thumbnailMediaStandard?.description || item.title}
              />
              {showDate && <p className="mt-2 text-white font-bold whitespace-pre-wrap text-[14px] tracking-widest leading-6 group-hover:text-chdGreen-light">{item.formattedDate}</p>}
              <p className="mt-2 text-white whitespace-pre-wrap text-[20px] leading-6 group-hover:text-chdGreen-light font-normal">{item.title}</p>
            </ShowEventPageSwiperDefaultStyles.SwiperItemImgWrapper>
          </ShowEventPageSwiperDefaultStyles.SwiperItem>
        </Link>
      </div>
    </ShowEventPageSwiperDefaultStyles.SwiperItemWrapper>
  ));

  return videos.length > 0 ? (
    <div className="flex flex-col my-4">
      {title && <p className="font-bold mx-[5px] uppercase text-[24px] text-chdGreen-light leading-[26.5px] my-4 tracking-widest">{title}</p>}
      <Swiper
        itemsArray={swiperItems}
        customStyles={ShowEventPageSwiperDefaultStyles}
        id={id}
      />
    </div>
  ) : (null);
}

export default VideoSwiper;
